import { Component, HostListener, ViewChild, AfterViewInit, ElementRef, OnInit } from '@angular/core';
import { NavbarComponent } from 'ng-uikit-pro-standard';
import { CategoryService } from './../../services/category.service';
import { first } from 'rxjs/operators'
// import { AngularFirestore } from '@angular/fire/firestore';
import { Router, NavigationExtras } from '@angular/router';
// import { AngularFireAuth } from '@angular/fire/auth';
import { CartService } from './../../services/cart.service';
import { UserService } from './../../services/user.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @ViewChild('nav', { static: true }) nav: NavbarComponent;

  public user: any;
  public categories: any;
  public my_categories: any;
  public subcategories: any;
  public collections: any = [];
  public carts: any;
  public totalAmount: number;
  public total : number = 0;
  public items : any  ;
  public person: any;
  public newCustomer: any;
  public hidebutton: boolean =true;
  public sumAll: any;
  public totalPrice: number = 0;
  public totalQuantity: number = 0;
  public sum: number = 0;
  public productItem: any;
  public my_button: boolean = true;
  public email: string;
  public response;
  public password: string;
  public cpassword: string;
  public fullname: string;
  public phone: string
  my_error
  constructor(
    public el: ElementRef,
    public cs: CategoryService,
    public crts: CartService,
    public us: UserService,
    public router: Router,
    ) {}
  

  ngOnInit() {

    this.user = JSON.parse(localStorage.getItem('user_details'));
    console.log(this.user);

    this.cs.getCategories().then(resp=>{
      resp.subscribe(res=>{
        this.my_categories = res;
        console.log(this.my_categories)
      })
    },
      error => {
        console.log(error)
      }
    )
    // return this.collections

    this.crts.getItemsFromCart().then((ref)=>{
      ref.subscribe(resp=>{
        this.carts= resp;
        console.log(this.carts)
      },
      error =>{
        this.my_error = error;
        console.log(this.my_error)
      }
      )
    })
  }

    register(name, email, phone, password, cpassword){
      if(password === cpassword && name && email && phone && password && cpassword){
        console.log(name, email, phone, password)
        this.us.register(JSON.stringify({name: name, email: email, phone: phone, password: password})).then(res=>{
          res.subscribe(async resp=>{
              console.log(resp)
              this.response = resp;
              console.log(this.response, this.response.created);
              if(res){
                await localStorage.setItem('token', JSON.stringify(this.response.access_token));
                await localStorage.setItem('user_details', JSON.stringify(this.response.data));
                await localStorage.setItem('isLoggedIn', 'true')
                alert('Registration successful, A verification link has been sent to your email, Kindly check your inbox and verify')
                location.reload()
              }
            },
            error =>{
              console.log(error)
            }
          )
        })
      }
      else {
        alert('password does not match')
      }
      if(!name || !email || !phone || !password){
        alert('Kindly fill all details')
      }
    }
  
    async login(email, password){
      try {
        this.us.login(JSON.stringify({email: email, password: password})).then(ref=>{
          ref.subscribe(async res=>{
            console.log(res),
            this.response = res;
            console.log(this.response, this.response.created);
            if(res){
              await localStorage.setItem('token', JSON.stringify(this.response.access_token));
              await localStorage.setItem('user_details', JSON.stringify(this.response.data));
              await localStorage.setItem('isLoggedIn', 'true')
              await alert('Login successful')
              await location.reload()
            }
          })
        })
      } catch (error) {
        console.log(error)
      }
    }
  
    async logout(){
      await localStorage.clear()
      await location.reload()
    }

    navigate(param){
        console.log(param)
        let navigationExtras: NavigationExtras = {
          queryParams: {
            gender: JSON.stringify(param)
          }
        };
      this.router.navigate(['categoryproducts'], navigationExtras).then(()=>{
        window.location.reload()
      })
    }

    navigateTo(page){
      this.router.navigateByUrl(page).then(()=>{
        window.location.reload()
      })
    }

    navigateWithParams(category, id, name){
      console.log(category, id, name)
        let navigationExtras: NavigationExtras = {
          queryParams: {
            id: JSON.stringify(id)
          }
        };
      this.router.navigate([category], navigationExtras).then(()=>{
        window.location.reload()
      })
    }
  }
  
